import graphql__d15334427bc21b87148e from "./__generated__/Steps_steppable.graphql.js";import { useCallback, useMemo, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import StepDetails from "./StepDetails";
import Modal from "../Modals/Modal";
import ButtonDiv from "../Buttons/ButtonDiv";
import { Desktop, NonDesktop } from "../Utils/ResponsiveQueries";
import { useFormatMessage } from "../Intl/Context";

const Steps = props => {
  const steppable = useFragment(Steps_steppable, props.steppable);
  const { steps, displayParticipativeModuleSteps } = steppable;

  const { title } = props;

  const [displayStepsModal, setDisplayStepsModal] = useState(false);

  const t = useFormatMessage();
  const seeAllLabel = t(intlMessages.seeAll);

  const currentStep = useMemo(() => {
    let currentStepIndex = 0;

    const step = steps.find((step, index) => {
      if (step.isCurrent) {
        currentStepIndex = index;
        return step;
      }

      return false;
    });

    // Use first step if none is found to be active ...
    if (!step) {
      return { step: steps[0], index: 0 };
    }

    return { step, index: currentStepIndex };
  }, [steps]);

  const hasManySteps = steps.length > 1;

  const className = classNames(
    "card",
    "box",
    "box-image",
    "margin-bottom-xs",
    "steps",
    "overflow-visible",
    {
      "steps-only-one": !hasManySteps
    }
  );

  const handleSeeAllClicked = useCallback(() => {
    if (hasManySteps) setDisplayStepsModal(true);
  }, [hasManySteps]);

  const handleSeeAllModalClosed = useCallback(() => {
    setDisplayStepsModal(false);
  }, []);

  if (!displayParticipativeModuleSteps) return null;

  return (
    <div className={className}>
      {/* Desktop appearance */}
      <Desktop>
        <div className="card-body">
          <ButtonDiv
            className="btn-unstyled btn-block text-left step-button"
            onClick={handleSeeAllClicked}
            disabled={!hasManySteps}
          >
            <span className="d-block steps-container steps-container-single">
              <StepDetails
                key={currentStep.step.id}
                index={currentStep.index}
                step={currentStep.step}
                seeAllLink={hasManySteps}
                displayNumber={hasManySteps}
              />
            </span>
          </ButtonDiv>
        </div>
      </Desktop>

      {/* Mobile and tablet appearance */}
      <NonDesktop>
        <div className="card-body">
          <div className="steps-container steps-container-single">
            <StepDetails
              key={currentStep.step.id}
              index={currentStep.index}
              step={currentStep.step}
              forceWhiteBackground={true}
              displayNumber={hasManySteps}
            />
          </div>

          {hasManySteps && (
            <button
              className="btn btn-link text-center d-block w-100 steps-see-all margin-bottom-xs"
              onClick={handleSeeAllClicked}
            >
              {seeAllLabel}
            </button>
          )}
        </div>
      </NonDesktop>

      {displayStepsModal && (
        <Modal
          isOpen={true}
          shouldCloseOnOverlayClick={true}
          onRequestClose={handleSeeAllModalClosed}
          title={title}
        >
          <div className="box">
            <div className="steps-container steps-container-list">
              {steps.map(step => (
                <StepDetails key={step.id} step={step} />
              ))}
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

const Steps_steppable = graphql__d15334427bc21b87148e;

export default Steps;

const intlMessages = defineMessages({
  seeAll: {
    id: "steps.seeAll",
    defaultMessage: "Voir toutes les étapes"
  }
});
